export function getSortableDate(dateStr: string): string {
  const parsed = new Date(dateStr);
  return !isNaN(parsed.getTime()) ? parsed.toISOString() : '';
}

export function getSortableTime(timeRangeStr: string): string {
  const [startRaw, endRaw] = timeRangeStr.split('-').map((s) => s.trim());
  const startDate = new Date('1970-01-01 ' + startRaw);
  const endDate = new Date('1970-01-01 ' + endRaw);
  if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
    return (
      `${startDate.getHours().toString().padStart(2, '0')}${startDate.getMinutes().toString().padStart(2, '0')}` +
      `-${endDate.getHours().toString().padStart(2, '0')}${endDate.getMinutes().toString().padStart(2, '0')}`
    );
  }
  return '';
}